import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from './message.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { IHttpPostResponse } from '../interfaces/http-post-response';

@Injectable({
  providedIn: 'root',
})
export class ToolsService {

  /** This can get turned off by modal dialogs, as they show error messages directly on the dialog. */
  showErrorAlerts: boolean;

  constructor(private toastr: ToastrService
    , private messageService: MessageService
  ) {
    this.showErrorAlerts = true;
  }

  /**
   * Shows a success toast message.
   * @param msg the message to display
   * @param title an optional title
   */
  public showSuccess(msg: string, title?: string) {
    this.toastr.success(msg, title);
  }

  /**
   * Shows a success toast message for Item added.
   * @param msg the message to display
   * @param title an optional title
   */
  public itemAdded(msg: string, title?: string) {
    this.toastr.success(msg, title, {
      toastClass: 'ngx-toastr ngx-toastr-custom'
    });
  }

  /**
   * Shows an informational toast message.
   * @param msg the message to display
   * @param title an optional title
   */
  public showInfo(msg: string, title?: string) {
    this.toastr.info(msg, title);
  }

  /**
   * Shows an error toast message.
   * @param msg the message to display
   * @param title an optional title
   */
  public showError(msg: string, title?: string) {
    this.toastr.error(msg, title);
  }

	public ProcessHttpResponse<TReturnType>(response: IHttpPostResponse<TReturnType>, codeToRun?: Function, errorCodetoRun?: Function): Promise<any> {
		if (response && response.succeeded) {
			if (codeToRun) {
				return codeToRun();
			} else {
				this.showSuccess(response.message);
			}
		} else {
      if(errorCodetoRun){
        errorCodetoRun();
      }
      if(response)
			this.showError(response.message);
		}
	}

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(showToasts: boolean = true, operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.log(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      if (showToasts) {
        this.showError(`${operation} failed: ${error.message}`);
      } else {
        this.messageService.sendErrorMessage(error.message);
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
